// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2We89","rootCenter":"LoadMoreObserver_rootCenter__25Ffg","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__-Ks7T"};